import styled from "styled-components";
import { theme } from "uikit";

const Content = styled.div`
	${theme.longWord}
`;

export default Content;
